import { requestJson } from "./apiClient";

export function getNotificationPreferences() {
  return requestJson("/api/account/notification-preferences");
}

export function updateNotificationPreferences(payload) {
  return requestJson("/api/account/notification-preferences", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function sendNotificationTestEmail() {
  return requestJson("/api/account/notification-preferences/test-email", {
    method: "POST",
  });
}
